/* eslint-disable import/prefer-default-export */
export const getCompanyName = () =>
  process.env.REACT_APP_COMPANY_NAME || 'Lobibox';
